<template>
  <div class="submitLookingSite">
    <img src="/static/images/success.jpg" />
    <div class="m-t10 fs17" style="color: #0ca309">操作成功</div>

    <div class="m-t25">请耐心等待我们平台服务人员</div>
    <div class="m-t10">对房源进行审核，过程注意接听平台</div>
    <div class="m-t10">客服电话联系确认</div>

    <van-button plain color="#0ca309" size="small" @click="onsubmit()"
      >完成</van-button
    >
  </div>
</template>

<script>
import { Button } from "vant";

export default {
  components: {
    [Button.name]: Button,
  },
  data() {
    return {};
  },
  methods: {
    onsubmit() {
      this.$router.go(-2);
    },
  },
};
</script>

<style lang="less" scoped>
.submitLookingSite {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 50px 0px;
  font-size: 14px;

  .van-button {
    width: 150px;
    font-size: 14px;
    position: absolute;
    bottom: 50px;
    border-radius: 4px;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/place/editPlaceSuccess.vue